var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('menu-item',{attrs:{"label":_vm.$t('embedded_hscmap')},model:{value:(_vm.module.show),callback:function ($$v) {_vm.$set(_vm.module, "show", $$v)},expression:"module.show"}})}
var staticRenderFns = []

export { render, staticRenderFns }